import { CSSProperties, HTMLAttributes } from 'react';

import { css } from '@compiled/react';

import { media } from '@atlaskit/primitives/responsive';

import { wacToken } from '@/libraries/design/foundations/index.ts';

export interface GenericTableColumnHeaderProps extends HTMLAttributes<HTMLTableCellElement> {
	colWidth?: string;
}

const headCellCss = css({
	fontWeight: 700,
	textAlign: 'left',
	color: wacToken('color.primary.black'),
	backgroundColor: wacToken('color.neutral.light0'),
	display: 'table-cell',
	padding: '14px',
	borderInlineEnd: `1px solid ${wacToken('color.neutral.light400')}`,
	':last-of-type': {
		borderInlineEnd: 'none',
	},
	width: 'var(--generic-table-column-header-width)',
	[media.below.sm]: {
		borderInlineEnd: `1px solid ${wacToken('color.neutral.light400')}`,
		borderInlineStart: 0,
		maxWidth: 'var(--generic-table-mobile-column-width)',
		minWidth: 'var(--generic-table-mobile-column-width)',
		width: 'var(--generic-table-mobile-column-width)',
		':first-of-type': {
			borderInlineEnd: 0,
			insetInlineStart: 0,
			position: 'sticky',
			zIndex: 3,
		},
		':first-of-type::after': {
			backgroundColor: wacToken('color.neutral.light400'),
			content: '""',
			insetBlock: 0,
			insetInlineEnd: 0,
			pointerEvents: 'none',
			position: 'absolute',
			width: '1px',
		},
	},
});

type GenericTableColumnHeaderStyle = CSSProperties & {
	'--generic-table-column-header-width': string | number;
};

export const GenericTableColumnHeader = ({
	colWidth,
	style,
	...props
}: GenericTableColumnHeaderProps) => {
	const { width, ...restStyle } = style ?? {};

	return (
		<th
			{...props}
			css={headCellCss}
			scope="col"
			style={
				{
					'--generic-table-column-header-width':
						colWidth ?? width ?? 'var(--generic-table-col-width)',
					...restStyle,
				} as GenericTableColumnHeaderStyle
			}
		/>
	);
};
